import loadable from '@loadable/component';

// TODO PASS-1209 Server JS Bundle is still including this
export const ClientOnlyModal = loadable(() => import('./modal'), {
  ssr: false,
});
